import React, { Fragment } from 'react';

import { BrowserRouter as Router, Link, withRouter } from 'react-router-dom';
import { CrossIcon, NavIcon } from './Icons';

const scrollShadowClassName = "scroll-shadow";

class AppHeader extends React.Component {
  constructor(props) {
    super(props);
    this.ref = null;
    this.isMobile = window.innerWidth <= 760;
    this.state = {
      onScreenNavigation: false,
    }
  }

  componentDidMount() {
    this.updateHeaderOnScroll();
    window.addEventListener("scroll", this.updateHeaderOnScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateHeaderOnScroll);
  }

  updateHeaderOnScroll = () => {
    if(document.firstElementChild.scrollTop > 100) {
      this.ref.classList.add(scrollShadowClassName);
    } else {
      this.ref.classList.remove(scrollShadowClassName);
    }
  }


  renderHeaderLogo = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100px" height="50px" viewBox="0 0 1008 1024">
      <path fill="#0F316E" d="M727 908.956c-9.166-.015-17.833-.133-26.496.004-3.972.062-5.697-1.257-5.611-5.5.224-11.023-.507-9.67 9.719-9.71 8.332-.031 16.731-.68 24.982.14 14.653 1.457 27.518-13.02 29.934-25.213 1.424-7.188.716-14.184-2.343-20.957-28.784-63.754-57.53-127.526-86.278-191.297a1552146.55 1552146.55 0 0 1-91.975-204.073c-8.485-18.83-16.913-37.684-25.43-56.498-5.618-12.407-13.55-14.922-25.327-8.106-4.956 2.868-9.287 6.48-12.63 11.18-2.763 3.884-5.496 7.787-8.504 12.054-.372-3.727 57.264-131.682 60.523-134.936 2.979 3.104 4.008 7.23 5.688 10.948 29.554 65.412 59.04 130.855 88.533 196.295 42.904 95.199 85.744 190.426 128.74 285.583 12.065 26.703 23.403 53.736 36.768 79.855 13.96 27.28 37.24 39.699 66.531 42.999 6.778.763 13.57 1.428 20.371 1.928 2.694.198 3.934 1.26 3.961 3.957.125 12.764.692 11.312-10.179 11.315-60.159.016-120.318.022-180.977.032zM229.312 703.404c34.565-76.726 68.956-153.115 103.37-229.494a677105.63 677105.63 0 0 1 89.321-198.138c6.983-15.486 13.966-30.973 21.013-46.43 11.378-24.956-2.92-50.097-30.289-52.96-3.044-.318-4.009-1.484-4-4.336.038-12.632-.716-10.304 9.845-10.345 27.66-.11 55.321.044 82.982-.077 10.174-.045 17.156 4.571 21.297 13.609 7.492 16.35 14.845 32.763 22.246 49.154 1.106 2.45 1.879 4.745.562 7.596-6.143 13.304-12.054 26.716-18.079 40.075-.528 1.17-.86 2.55-2.27 3.122-1.682-.263-1.857-1.811-2.375-2.938-3.34-7.263-6.726-14.509-9.849-21.866-3.479-8.196-9.859-11.084-18.318-11.057-8.352.028-14.216 3.3-17.733 11.16-16.662 37.242-33.492 74.409-50.256 111.605-31.61 70.14-63.22 140.282-94.826 210.424-28.527 63.31-57.16 126.573-85.46 189.985-4.392 9.842-10.858 14.08-21.628 13.934-28.489-.386-56.986-.118-85.48-.145-2.133-.001-4.326.386-7.006-.777.866-4.663 2.986-8.884 5.53-12.844 1.11-1.73 3.389-.939 5.166-.992 11.95-.357 24.01 1.157 35.805-1.906 18.72-4.863 32.348-15.817 40.18-33.712 3.27-7.476 6.72-14.874 10.252-22.647zm493.976-256.016c34.98-77.623 69.795-154.904 104.61-232.186 6.02-13.361 12.004-26.739 18.079-40.075 4.046-8.881 10.802-13.553 20.803-13.495 19.493.112 38.987.02 58.48.03 1.638.001 3.275.135 5.663.24-1.134 4.97-3.414 8.953-5.516 12.968-.914 1.748-2.868 1.422-4.51 1.429-6.664.026-13.33.116-19.992-.012-8.096-.155-13.445 3.42-16.769 10.856-16.851 37.697-33.844 75.331-50.812 112.977-25.588 56.774-51.202 113.535-76.79 170.308-8.895 19.734-17.721 39.5-26.658 59.214-.847 1.868-1.121 4.232-3.91 5.557-2.103-4.542-4.213-9.003-6.242-13.5-4.451-9.866-8.75-19.803-13.36-29.593-1.285-2.726-1.094-4.855.123-7.49 5.656-12.245 11.11-24.583 16.801-37.228zm17.306-152.184c-8.274-.006-16.099-.07-23.922.01-3.08.03-4.603-.752-5.236-4.298-2.698-15.099-13.516-24.588-27.544-24.744-14.924-.165-25.478 8.673-28.803 24.38-.698 3.301-1.98 4.826-5.601 4.721-7.984-.23-15.98-.037-23.97-.066-1.445-.005-3.014.283-4.935-1.692l62.559-108.422 62.544 108.294c-1.606 2.294-3.24 1.62-5.092 1.817zM284 908.964c-20.333-.019-40.166-.145-59.998.022-4.74.04-6.585-1.475-6.34-6.333.45-8.883-1.527-8.123 8.305-11.149 10.818-3.33 21.484-7.147 32.286-10.529 25.653-8.032 43.705-24.752 55.869-48.349 2.575-4.995 5.37-9.877 8.482-15.575 1.275 3.046-.24 4.85-.905 6.608-3.396 8.984-5.57 18.141-4.6 27.83 1.072 10.707 5.73 19.374 14.725 25.49 12.561 8.54 26.848 12.252 41.571 14.699 3.94.654 7.871 1.427 11.838 1.811 2.982.29 3.852 1.704 3.982 4.523.504 10.907.58 10.905-10.218 10.91-31.499.015-62.998.029-94.997.042z"/>
      <path fill="#0F316E" d="M424.86 626.875c-10.17 6.397-18.186 14.7-25.724 23.545l-1.105-.823 39.612-87.835c1.654 3.568.495 7.009 1.472 10.486 2.935 10.452 10.835 17.046 21.587 17.532 36.925 1.666 73.847 3.404 110.769 5.132 4.655.218 9.304.55 13.957.817 3.972.23 7.23 1.922 10.37 4.797-4.187 2.747-8.716 1.881-12.825 2.373-19 2.275-38.12 3.182-57.207 4.512-21.4 1.491-42.935 1.422-64.178 4.781-13.164 2.082-25.218 7.305-36.728 14.683zm332.158-455.526c3.504 22.457-1.386 42.396-15.044 60.103-3.713 4.814-6.373 7.255-9.69 9.019-5.396-5.549-5.275-6.355-.63-11.695 16.67-19.163 21.69-41.147 13.416-65.134-8.338-24.174-25.846-39.046-51.112-43.255-35.498-5.915-67.866 16.574-75.028 51.68-4.348 21.31 1.394 40.218 15.563 56.577 4.88 5.635 5.004 5.604-.26 11.816-2.334.087-3.443-1.834-4.73-3.222-20.62-22.254-26.735-48.295-17.038-76.753 9.81-28.785 30.883-45.498 61.206-49.895 36.62-5.31 75.087 18.801 83.347 60.759z"/>
    </svg>
  )

  renderOnScreenNavigation = () => {

    return (
      <div className="on-screen-navigation-container" onClick={() => this.setState({onScreenNavigation: false})}>
        <div className="navigation-actions">
          <h3 onClick={() => this.props.history.push("/")}>Home</h3>
          <h3 onClick={() => this.props.history.push("/about")}>About Us</h3>
          <h3 onClick={() => this.props.history.push("/services")}>Services</h3>
          <h3 onClick={() => this.props.history.push("/emi")}>EMI Calculator</h3>
          <h3 onClick={() => this.props.history.push("/contact")}>Contact Us</h3>
        </div>
      </div>
    )
  }

  renderMobileHeader = () => {

    return (
      <Fragment>
        <div className='mobile-header'>
          <div className='header-logo' onClick={() => this.props.history.push("/")}>
            {this.renderHeaderLogo()}
          </div>
          <div className='header-nav' onClick={() => this.setState({onScreenNavigation: !this.state.onScreenNavigation})}>
            {this.state.onScreenNavigation ? <CrossIcon/> : <NavIcon/>}
          </div>
        </div>
        {
          this.state.onScreenNavigation &&
          this.renderOnScreenNavigation()
        }
      </Fragment>
    )
  }

  renderWebHeader = () => {

    return (
      <ul>
        <li><Link to="">Home</Link></li>
        <div className='vertical' />
        <li><Link to="about" replace>About Us</Link></li>
        <div className='vertical' />
        <li><Link to="services">Services</Link></li>
        <div className='vertical' />
        <li><Link to="emi">EMI Calculator</Link></li>
        <div className='vertical' />
        <li><Link to="contact">Contact Us</Link></li>
      </ul>
    )
  }


  render() {

    return (
      <div className="cmp" ref={ref => this.ref = ref}>
        {this.isMobile ? this.renderMobileHeader(): this.renderWebHeader()}
      </div>
    )
  }
}

export default withRouter(AppHeader);
